import type { Quest } from '../types';

// === 업적 (영구) ===
const achievementMilestones = (
  baseId: string, title: (n: number) => string, metric: Quest['goal']['metric'],
  targets: number[], rewardOutfits: string[]
): Quest[] => targets.map((t, i) => ({
  id: `${baseId}_${t}`, type: 'achievement', title: title(t), description: '',
  goal: { metric, target: t },
  reward: { stars: 5 + i * 5, coins: 50 + i * 50, outfitId: rewardOutfits[i] }
}));

const ACHIEVEMENT_OUTFITS = [
  'pin_pink_ribbon', 'pin_star', 'pin_heart', 'pin_flower', 'pin_crown',
  'glasses_round', 'glasses_pink_sun', 'glasses_star', 'glasses_heart',
  'bag_pink_backpack', 'bag_animal', 'bag_unicorn',
  'shoes_pink_boots', 'shoes_yellow_sandals', 'shoes_colorful_boots',
];

export const QUESTS: Quest[] = [
  // 의상 수집 (5개)
  ...achievementMilestones('outfits', n => `의상 ${n}개 수집`, 'outfits_owned', [5, 15, 30, 50, 100], ACHIEVEMENT_OUTFITS.slice(0, 5)),
  // 미니게임 (5개)
  ...achievementMilestones('minigames', n => `미니게임 ${n}회 플레이`, 'minigames_played', [5, 25, 75, 200, 500], ACHIEVEMENT_OUTFITS.slice(5, 10)),
  // 라이벌 승리 (5개)
  ...achievementMilestones('rivals', n => `라이벌 ${n}승`, 'rival_wins', [1, 5, 15, 30, 100], ACHIEVEMENT_OUTFITS.slice(10, 15)),
  // 수학 단계 (5개)
  ...achievementMilestones('math', n => `수학 ${n}단계 클리어`, 'math_stages_cleared', [1, 5, 10, 25, 50], ['pin_star', 'glasses_star', 'pin_heart', 'pin_crown', 'glasses_heart']),
  // 펫 (4개)
  ...achievementMilestones('pets', n => `펫 ${n}마리 수집`, 'pets_owned', [1, 3, 5, 10], ['bag_animal', 'pin_flower', 'bag_unicorn', 'pin_crown']),
  // 코디 저장 (3개)
  ...achievementMilestones('saved', n => `코디 ${n}개 저장`, 'outfits_saved', [1, 3, 5], ['pin_pink_ribbon', 'pin_star', 'glasses_star']),
  // 일일 로그인 (3개)
  ...achievementMilestones('daily', n => `${n}일 연속 플레이`, 'days_played', [3, 7, 30], ['pin_flower', 'bag_pink_backpack', 'pin_crown']),
];

// === 일일 퀘스트 풀 (랜덤 5개 선택) ===
export const DAILY_POOL: Omit<Quest, 'expiresAt'>[] = [
  { id: 'daily_minigame3', type: 'daily', title: '미니게임 3회 플레이', description: '아무 미니게임이나 OK', goal: { metric: 'minigames_played', target: 3 }, reward: { stars: 10, coins: 100 } },
  { id: 'daily_outfits5', type: 'daily', title: '의상 5번 입어보기', description: '옷장에서 입혀보세요', goal: { metric: 'outfit_equips', target: 5 }, reward: { stars: 10, coins: 80 } },
  { id: 'daily_pet_happy', type: 'daily', title: '펫 행복도 80% 달성', description: '쓰다듬어줘요', goal: { metric: 'pet_happiness_max', target: 80 }, reward: { stars: 15, coins: 100 } },
  { id: 'daily_rival', type: 'daily', title: '라이벌 1회 도전', description: '이기지 못해도 OK', goal: { metric: 'rival_wins', target: 1 }, reward: { stars: 20, coins: 150 } },
  { id: 'daily_math', type: 'daily', title: '수학 단계 1번 클리어', description: '학습 시간!', goal: { metric: 'math_stages_cleared', target: 1 }, reward: { stars: 25, coins: 150 } },
  { id: 'daily_rhythm', type: 'daily', title: '리듬게임 100점', description: '한 곡 잘 쳐봐요', goal: { metric: 'rhythm_game_score', target: 100 }, reward: { stars: 15, coins: 120 } },
];

// === 주간 퀘스트 풀 ===
export const WEEKLY_POOL: Omit<Quest, 'expiresAt'>[] = [
  { id: 'weekly_rivals5', type: 'weekly', title: '라이벌 5승', description: '이번 주!', goal: { metric: 'rival_wins', target: 5 }, reward: { stars: 50, coins: 500, outfitId: 'pin_heart' } },
  { id: 'weekly_math10', type: 'weekly', title: '수학 10단계', description: '집중!', goal: { metric: 'math_stages_cleared', target: 10 }, reward: { stars: 60, coins: 500, outfitId: 'glasses_star' } },
  { id: 'weekly_outfits15', type: 'weekly', title: '의상 15개 모으기', description: '총합', goal: { metric: 'outfits_owned', target: 15 }, reward: { stars: 50, coins: 600, outfitId: 'bag_animal' } },
];

export const QUESTS_BY_ID: Record<string, Quest> = Object.fromEntries(QUESTS.map(q => [q.id, q]));
